import { Flex, Text, Button } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useLocalePath } from '../hooks/useLocalePath.js'

interface Props {
  /** Localized message. Defaults to the generic "page not found". */
  message?: string
}

/**
 * Friendly not-found state with a route back to the language home. Used both as
 * the router catch-all (unknown URLs) and by content pages when a course /
 * track / lesson / module id doesn't resolve.
 */
export function NotFoundView({ message }: Props) {
  const { t } = useTranslation('common')
  const navigate = useNavigate()
  const localePath = useLocalePath()

  return (
    <Flex direction="column" align="center" justify="center" minH="50vh" gap={4} textAlign="center" px={4}>
      <Text fontSize="4xl" aria-hidden="true">🔍</Text>
      <Text as="h1" color="acp.inkSoft" fontSize="lg">{message ?? t('pageNotFound')}</Text>
      <Button variant={'acp-primary' as any} onClick={() => navigate(localePath('/'))}>
        {t('home')}
      </Button>
    </Flex>
  )
}
